module.exports = __webpack_public_path__ + "img/wishlist.f4a917d.png";